import { render, staticRenderFns } from "./DonutChart25.vue?vue&type=template&id=4b28ee9a&scoped=true&"
import script from "./DonutChart25.vue?vue&type=script&lang=js&"
export * from "./DonutChart25.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b28ee9a",
  null
  
)

export default component.exports